import React from "react";

import { number, string } from "prop-types";

import "./Span.m.css";

const Span = ({ children, customStyleName, customClassName }) => {
  const Tag = `span`;
  return (
    <Tag styleName={`${customStyleName}`} className={`headline ${customClassName}`}>
      {children}
    </Tag>
  );
};

Span.defaultProps = {
  customStyleName: "",
};

Span.propTypes = {
  customStyleName: string.isRequired,
};

export default Span;
